import * as PropTypes from "prop-types";
import {Component} from "react";

export class UrlProvider {
  constructor(basePath) {
    this.basePath = basePath;
  }
}

export class DataProvider extends Component {
  constructor(props) {
    super(props);
    this.onLoading = this.onLoading.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
  }

  onLoading() {
    if (this.props.onLoading) {
      this.props.onLoading();
    }
  }

  onSuccess(response) {
    if (this.props.onSuccess) {
      this.props.onSuccess(response);
    } else if (this.props.onDone) {
      this.props.onDone();
    }
  }

  onError(error) {
    if (this.props.onError) {
      this.props.onError(error);
    } else if (this.props.onDone) {
      this.props.onDone();
    }
  }
}

DataProvider.propTypes = {
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onDone: PropTypes.func
};
